import { useState } from 'react';
import toast from 'react-hot-toast';
import FilesDrawer from '../drawers/FilesDrawer';
import { downloadMedicalVerificationPdf } from '~/utils/medicalVerificationPdf';

interface Props {
    campaign: any;
    patient: any;
    application: any;
}

const FilesTab: React.FC<Props> = ({ campaign, patient, application }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);

    const handleMedicalVerification = async () => {
        setIsGenerating(true);
        try {
            await downloadMedicalVerificationPdf(campaign, patient, application);
        } catch (err) {
            console.error('Error generating medical verification form:', err);
            toast.error('Failed to generate Medical Verification Form');
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className='flex flex-wrap gap-4 p-4'>
            <button
                type='button'
                className='rounded-full border-[2px] border-black px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:bg-black hover:text-white'
                onClick={() => setIsDrawerOpen(true)}
            >
                Letters Merged Docx
            </button>
            <button
                type='button'
                className='rounded-full border-[2px] border-black px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:bg-black hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
                onClick={handleMedicalVerification}
                disabled={isGenerating}
            >
                {isGenerating ? 'Generating...' : 'Medical Verification Form'}
            </button>
            <FilesDrawer
                isOpen={isDrawerOpen}
                setIsOpen={setIsDrawerOpen}
                campaign={campaign}
                patient={patient}
            />
        </div>
    );
};

export default FilesTab;
